<template>
  <div class="scroll-top-btn" v-show="showBackToTop" @click="goTop">
    <div class="icon"></div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  props: {},
  data() {
    return {
      showBackToTop: false,
    };
  },
  mounted() {
    this.setBackToTop();
  },
  methods: {
    setBackToTop() {
      window.addEventListener('scroll', () => {
        const st = document.body.scrollTop || document.documentElement.scrollTop;

        if (st > 350) {
          this.showBackToTop = true;
        } else {
          this.showBackToTop = false;
        }
      });
    },
    goTop(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      const st = document.body.scrollTop || document.documentElement.scrollTop;
      const time = st * 0.2 + 200;

      function esae(t) {
        return (t * 2) < 1 ?
          4 * t * t * t :
          (4 * (t - 1) * (t - 1) * (t - 1) + 1);
      }

      let start;
      function animate(timestamp) {
        if (!start) start = timestamp;

        const ds = timestamp - start;

        const dp = ds / time;
        scrollTo(0, st - st * esae(dp));

        if (ds < time) {
          requestAnimationFrame(animate);
        } else {
          scrollTo(0, 0);
        }
      }

      requestAnimationFrame(animate);
    },
  },
};
</script>

<style lang="less" scoped>
.scroll-top-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0px 4px 12px 0px rgba(30,43,61,0.1);
  border: 1px solid #E9EEF2;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover{
    color: #599FFF;
    .icon{
      background: url(../../../assets/imgs/homepage/fixed-right-service/scroll-top-active.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .icon{
    width: 32px;
    height: 32px;
    background: url(../../../assets/imgs/homepage/fixed-right-service/scroll-top.png) no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/scroll-top-btn.vue